import "./contactsImporter.scss";

export type ImportedContact = {
    firstName?: string;
    lastName?: string;
    email?: string;
};

export type ContactsImporterOptions = {
    cloudSpongeOptions?: {},
    onImport: (contacts: ImportedContact[]) => void;
    launchButtonSelector?: string;
};

export class ContactsImporter {
    private readonly launchButtons: HTMLButtonElement[];

    public constructor(
        container: HTMLElement,
        private readonly options: ContactsImporterOptions
    ) {
        this.launchButtons = Array.from(container.querySelectorAll<HTMLButtonElement>(options.launchButtonSelector ?? '.cloudsponge-launch-btn'));

        this.setLaunchButtons();
        this.setCloudSponge();
    }

    private setLaunchButtons(): void {
        this.launchButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const source = button.dataset.cloudspongeSource;
                window.cloudsponge?.launch(source);
            });
        });
    }

    private setCloudSponge(): void {
        window.cloudsponge?.init({
            skipSourceMenu: true,
            ...this.options.cloudSpongeOptions,
            afterSubmitContacts: (contacts, source, owner) => {
                const mapped = contacts.map(contact => ({
                    firstName: contact.first_name,
                    lastName: contact.last_name,
                    email: contact.selectedEmail()
                }));
                this.options.onImport(mapped);
            }
        });
    }
}
